
// The single midpoint calculation every tool that needs one - the
// standalone Midpoint tool and the Midline tool's per-connector midpoints -
// must go through, so the math is defined exactly once.
export function computeMidpoint(a, b){
	return [
		(a[0] + b[0]) / 2,
		(a[1] + b[1]) / 2,
		(a[2] + b[2]) / 2,
	];
}
